/* eslint-disable kf/const-naming-convention */
/* eslint-disable no-undef */
const observerCache = new Map();
const registry = new FinalizationRegistry((heldValue) => {
  console.info("observer is garbage collected ", heldValue);
  const observer = observerCache.get(heldValue);
  if (observer && !observer.deref()) observerCache.delete(heldValue);
});

export class Observer {
  static create(uId) {
    let cachedObserver = this.get(uId);
    if (cachedObserver) {
      return cachedObserver;
    }
    const observer = new Observer(uId);
    observerCache.set(uId, new WeakRef(observer));
    registry.register(observer, uId);
    return observer;
  }

  /*
   * Once observer is garbage collected then we need to delete the entry from Map
   * then we create & return the new observer. If not garbage collected then we return
   * the exisiting observer from cache.
   */
  static get(uId) {
    let observerFromCache = observerCache.get(uId);
    if (observerFromCache && !observerFromCache.deref()) {
      observerCache.delete(uId);
      return this.create(uId);
    } else {
      return observerFromCache?.deref();
    }
  }

  constructor(uid) {
    this.id = uid;
    this.observers = [];
  }

  _delete(cb) {
    this.observers = this.observers.filter((cbs) => cbs !== cb);
  }

  observe(cb) {
    this.observers.push(cb);
    return this._delete.bind(this, cb);
  }

  notify(value) {
    this.observers.forEach((cb) => cb(value));
  }
}
